import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_admin/cardapio')({
  component: CardapioLayout,
})

function CardapioLayout() {
  return <Outlet />
}
